import { lazy } from 'react';

// project imports
//import MinimalLayout from 'layout/MinimalLayout';
//import NavMotion from 'layout/NavMotion';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import HearingAidPrices from 'views/pages/hearingAidPrices';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

const Users = Loadable(lazy(() => import('views/pages/users')));
const UserDetail = Loadable(lazy(() => import('views/pages/users/UserDetail')));
const HearTests = Loadable(lazy(() => import('views/pages/hearTests')));
const HearTestDetail = Loadable(lazy(() => import('views/pages/hearTests/HearTestDetail')));
const Surveys = Loadable(lazy(() => import('views/pages/surveys')));
const SurveyDetail = Loadable(lazy(() => import('views/pages/surveys/SurveyDetail')));
const NoiseTest = Loadable(lazy(() => import('views/pages/hearingNoiseTest')));
const NoiseTestDetail = Loadable(lazy(() => import('views/pages/hearingNoiseTest/HearingNoiseTestDetail')));
const Banners = Loadable(lazy(() => import('views/pages/banners')));
const BannerDetail = Loadable(lazy(() => import('views/pages/banners/BannerDetail')));
const Communitys = Loadable(lazy(() => import('views/pages/communitys')));
const CommunityDetail = Loadable(lazy(() => import('views/pages/communitys/CommunityDetail')));
const Comments = Loadable(lazy(() => import('views/pages/comments')));
const CommentDetail = Loadable(lazy(() => import('views/pages/comments/CommentDetail')));
const CustomerCenters = Loadable(lazy(() => import('views/pages/customerCenters')));
const CustomerCenterDetail = Loadable(lazy(() => import('views/pages/customerCenters/CustomerCenterDetail')));
const DataRoomsNew = Loadable(lazy(() => import('views/pages/dataRoomsNew')));
const DataRoomNewDetail = Loadable(lazy(() => import('views/pages/dataRoomsNew/DataRoomDetail')));
const NewsLetters = Loadable(lazy(() => import('views/pages/newsLetters')));
const NewsLetterDetail = Loadable(lazy(() => import('views/pages/newsLetters/NewsLetterDetail')));
const ExpertFeedbacks = Loadable(lazy(() => import('views/pages/expertFeedbacks')));
const ExpertFeedbackDetail = Loadable(lazy(() => import('views/pages/expertFeedbacks/ExpertFeedbackDetail')));
const ExcelDatas = Loadable(lazy(() => import('views/pages/excelDatas')));
const ExcelDataDetail = Loadable(lazy(() => import('views/pages/excelDatas/ExcelDataDetail')));
const Requests = Loadable(lazy(() => import('views/pages/requests')));
const RequestDetail = Loadable(lazy(() => import('views/pages/requests/RequestDetail')));
const Places = Loadable(lazy(() => import('views/pages/places')));
const PlaceDetail = Loadable(lazy(() => import('views/pages/places/PlaceDetail')));
const Reviews = Loadable(lazy(() => import('views/pages/reviews')));
const ReviewDetail = Loadable(lazy(() => import('views/pages/reviews/ReviewDetail')));
const HearingCertifications = Loadable(lazy(() => import('views/pages/hearingCertifications')));
const HearingCertificationDetail = Loadable(lazy(() => import('views/pages/hearingCertifications/HearingCertificationDetail')));
const Reports = Loadable(lazy(() => import('views/pages/reports')));
const ReportDetail = Loadable(lazy(() => import('views/pages/reports/ReportDetail')));

// kiosk menus
const KioskBanners = Loadable(lazy(() => import('views/kiosk/banners')));
const KioskBannerDetail = Loadable(lazy(() => import('views/kiosk/banners/BannerDetail')));
const KioskUsers = Loadable(lazy(() => import('views/kiosk/users')));
const KioskDataRooms = Loadable(lazy(() => import('views/kiosk/dataRooms')));
const KioskDataRoomDetail = Loadable(lazy(() => import('views/kiosk/dataRooms/DataRoomDetail')));
const KioskUserDetail = Loadable(lazy(() => import('views/kiosk/users/UserDetail')));
const KioskSurveys = Loadable(lazy(() => import('views/kiosk/surveys')));
const KioskSurveyDetail = Loadable(lazy(() => import('views/kiosk/surveys/SurveyDetail')));
const KioskHearTests = Loadable(lazy(() => import('views/kiosk/hearTests')));
const KioskHearTestsDetail = Loadable(lazy(() => import('views/kiosk/hearTests/HearTestDetail')));
const KioskNoiseTest = Loadable(lazy(() => import('views/kiosk/hearingNoiseTest')));
const KioskNoiseTestDetail = Loadable(lazy(() => import('views/kiosk/hearingNoiseTest/HearingNoiseTestDetail')));
const KioskEardrumTests = Loadable(lazy(() => import('views/kiosk/eardrumTests')));
const KioskEardrumTestsDetail = Loadable(lazy(() => import('views/kiosk/eardrumTests/EardrumTestsDetail')));
const KioskTotalTest = Loadable(lazy(() => import('views/kiosk/hearingTotalTest')));
const KioskTotalTestDetail = Loadable(lazy(() => import('views/kiosk/hearingTotalTest/HearingTotalTestDetail')));
const KioskGeneralCodes = Loadable(lazy(() => import('views/kiosk/generalCodes')));
const KioskGeneralCodesDetail = Loadable(lazy(() => import('views/kiosk/generalCodes/GeneralCodesDetail')));
const KioskPCMSets = Loadable(lazy(() => import('views/kiosk/pcmSets')));
const KioskPCMSetsDetail = Loadable(lazy(() => import('views/kiosk/pcmSets/PCMSetsDetail')));
const KioskPCMSetsDetailRow = Loadable(lazy(() => import('views/kiosk/pcmSets/PCMSetsDetailRow')));
const KioskPCMSetsDetailDual = Loadable(lazy(() => import('views/kiosk/pcmSets/PCMSetsDetailDual')));
const KioskPCMSetsDetailArray = Loadable(lazy(() => import('views/kiosk/pcmSets/PCMSetsDetailArray')));
const KioskPCMSetsDetailArrayDual = Loadable(lazy(() => import('views/kiosk/pcmSets/PCMSetsDetailArrayDual')));
const KioskGpsLocations = Loadable(lazy(() => import('views/kiosk/gpsLocations')));
const KioskDeviceList = Loadable(lazy(() => import('views/kiosk/deviceList')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    // ======================== hearingaid menus ========================
    {
      path: '/',
      element: <Users />
    },
    {
      path: '/users',
      element: <Users />
    },
    {
      path: '/users-detail',
      element: <UserDetail />
    },
    {
      path: '/hear-tests',
      element: <HearTests />
    },
    {
      path: '/hear-tests-detail',
      element: <HearTestDetail />
    },
    {
      path: '/surveys',
      element: <Surveys />
    },
    {
      path: '/surveys-detail',
      element: <SurveyDetail />
    },
    {
      path: '/noise-test',
      element: <NoiseTest />
    },
    {
      path: '/noise-test-detail',
      element: <NoiseTestDetail />
    },
    {
      path: '/banners',
      element: <Banners />
    },
    {
      path: '/banners-detail',
      element: <BannerDetail />
    },
    {
      path: '/communitys',
      element: <Communitys />
    },
    {
      path: '/communitys-detail',
      element: <CommunityDetail />
    },
    {
      path: '/comments',
      element: <Comments />
    },
    {
      path: '/comments-detail',
      element: <CommentDetail />
    },
    {
      path: '/customer-centers',
      element: <CustomerCenters />
    },
    {
      path: '/customer-centers-detail',
      element: <CustomerCenterDetail />
    },
    {
      path: '/data-rooms-new',
      element: <DataRoomsNew />
    },
    {
      path: '/data-rooms-new-detail',
      element: <DataRoomNewDetail />
    },
    {
      path: '/expert-feedbacks',
      element: <ExpertFeedbacks />
    },
    {
      path: '/expert-feedbacks-detail',
      element: <ExpertFeedbackDetail />
    },
    {
      path: '/excel-datas',
      element: <ExcelDatas />
    },
    {
      path: '/excel-datas-detail',
      element: <ExcelDataDetail />
    },
    {
      path: '/hearing-certifications',
      element: <HearingCertifications />
    },
    {
      path: '/hearing-certifications-detail',
      element: <HearingCertificationDetail />
    },
    {
      path: '/news-letters',
      element: <NewsLetters />
    },
    {
      path: '/news-letters-detail',
      element: <NewsLetterDetail />
    },
    {
      path: '/requests',
      element: <Requests />
    },
    {
      path: '/requests-detail',
      element: <RequestDetail />
    },
    {
      path: '/places',
      element: <Places />
    },
    {
      path: '/places-detail',
      element: <PlaceDetail />
    },
    {
      path: '/reviews',
      element: <Reviews />
    },
    {
      path: '/reviews-detail',
      element: <ReviewDetail />
    },
    {
      path: '/reports',
      element: <Reports />
    },
    {
      path: '/reports-detail',
      element: <ReportDetail />
    },
    {
      path: '/sample-page',
      element: <SamplePage />
    },
    // ======================== kiosk menus ========================
    {
      path: '/kiosk-banners',
      element: <KioskBanners />
    },
    {
      path: '/kiosk-banners-detail',
      element: <KioskBannerDetail />
    },
    {
      path: '/kiosk-users',
      element: <KioskUsers />
    },
    {
      path: '/kiosk-users-detail',
      element: <KioskUserDetail />
    },
    {
      path: '/kiosk-data-rooms',
      element: <KioskDataRooms />
    },
    {
      path: 'kiosk-data-rooms-detail',
      element: <KioskDataRoomDetail />
    },
    {
      path: '/kiosk-surveys',
      element: <KioskSurveys />
    },
    {
      path: '/kiosk-surveys-detail',
      element: <KioskSurveyDetail />
    },
    {
      path: '/kiosk-total-tests',
      element: <KioskTotalTest />
    },
    {
      path: '/kiosk-total-tests-detail',
      element: <KioskTotalTestDetail />
    },
    {
      path: '/kiosk-hear-tests',
      element: <KioskHearTests />
    },
    {
      path: '/kiosk-hear-tests-detail',
      element: <KioskHearTestsDetail />
    },
    {
      path: '/kiosk-noise-tests',
      element: <KioskNoiseTest />
    },
    {
      path: '/kiosk-noise-tests-detail',
      element: <KioskNoiseTestDetail />
    },
    {
      path: '/kiosk-eardrum-tests',
      element: <KioskEardrumTests />
    },
    {
      path: '/kiosk-eardrum-tests-detail',
      element: <KioskEardrumTestsDetail />
    },
    {
      path: '/kiosk-general-codes',
      element: <KioskGeneralCodes />
    },
    {
      path: '/kiosk-general-codes-detail',
      element: <KioskGeneralCodesDetail />
    },
    {
      path: '/kiosk-pcm-sets',
      element: <KioskPCMSets />
    },
    {
      path: '/kiosk-pcm-sets-detail',
      element: <KioskPCMSetsDetail />
    },
    {
      path: '/kiosk-pcm-sets-detail-row',
      element: <KioskPCMSetsDetailRow />
    },
    {
      path: '/kiosk-pcm-sets-detail-dual',
      element: <KioskPCMSetsDetailDual />
    },
    {
      path: '/kiosk-pcm-sets-detail-array',
      element: <KioskPCMSetsDetailArray />
    },
    {
      path: '/kiosk-pcm-sets-detail-array-dual',
      element: <KioskPCMSetsDetailArrayDual />
    },  
    {
      path: '/kiosk-gps-locations',
      element: <KioskGpsLocations />
    }, 
    {
      path: '/kiosk-devices-list',
      element: <KioskDeviceList />
    }, 
  ]
};

export default MainRoutes;
